/**
 * ══════════════════════════════════════════════════════════════════════════
 * LINHA DE KIT — o +/- que anda de kit em kit
 * ══════════════════════════════════════════════════════════════════════════
 *
 * A PDP carimba `_kit` na linha quando a pessoa escolhe o cartão "2 unidades"
 * ou "3 unidades". Nessa linha `quantity` conta FRASCOS: dois kits de três são
 * quantidade 6. O carrinho mostra KITS, porque é isso que a pessoa escolheu —
 * e porque qualquer número que não feche kits inteiros perde o desconto na
 * hora (a Function só desconta múltiplo exato do kit).
 *
 * Daí este arquivo: o botão + soma um kit, o − tira um kit, e o campo aceita
 * número de kits. Quem desenha o controle é `snippets/cart-kit-quantidade`.
 *
 * DUAS ARMADILHAS QUE JÁ CUSTARAM CARO AQUI
 *
 * 1. `window.halo` não existe. O objeto do tema vive dentro do IIFE do
 *    `theme.js`, então todo `halo.updateSidebarCart()` escrito de fora é
 *    código morto — o carrinho ficava certo no servidor e errado na tela.
 *    A gaveta é redesenhada na mão, pelo mesmo caminho do tema.
 *
 * 2. A gaveta depende de `<script>` inline. Cada linha traz o estoque das
 *    variantes num script, e `innerHTML` não executa script: montada assim, a
 *    gaveta perde o +/-. Por isso `$().html()` do jQuery, que executa.
 */
(function () {
  'use strict';

  var ROTA = (window.routes && window.routes.root) || '';
  var ocupado = false;

  /** O fetch de antes de qualquer app embrulhar o nosso. */
  var fetchOriginal = window.fetch.bind(window);

  function pedir(url, corpo) {
    var opcoes = { headers: { Accept: 'application/json' } };
    if (corpo) {
      opcoes.method = 'POST';
      opcoes.headers['Content-Type'] = 'application/json';
      opcoes.body = JSON.stringify(corpo);
    }
    return fetchOriginal(url, opcoes).then(function (r) { return r.json(); });
  }

  /**
   * Redesenha a gaveta. Cópia do caminho do `theme.js` — ver a armadilha 1.
   */
  function redesenharGaveta() {
    var $ = window.jQuery;
    if (!$) return Promise.resolve();
    var $wrapper = $('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
    if (!$wrapper.length) return Promise.resolve();
    return fetchOriginal(ROTA + '/cart?view=ajax_side_cart', { cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) { $wrapper.html($(html)); })
      .catch(function () {});
  }

  function sincronizarTela(cart) {
    try {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
      });
      if (window.cartStrings) {
        document.querySelectorAll('[data-cart-text]').forEach(function (el) {
          el.textContent = cart.item_count === 1 ? window.cartStrings.item : window.cartStrings.items;
        });
      }
    } catch (e) {}

    /* Na página do carrinho não há gaveta para redesenhar e o total, o frete e
       os descontos vivem no HTML da seção. Recarregar é o caminho honesto: a
       página inteira volta do servidor, sem meio-termo entre o que está na
       tela e o que está na sacola. */
    if (!document.querySelector('#halo-cart-sidebar')) {
      window.location.reload();
      return Promise.resolve();
    }

    return redesenharGaveta().then(function () {
      try {
        document.querySelectorAll('[data-free-shipping-wrapper]').forEach(function (el) {
          el.dispatchEvent(new Event('change', { bubbles: true }));
        });
      } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('cart-update', { detail: cart })); } catch (e) {}
    });
  }

  /**
   * Grava a nova quantidade (em FRASCOS) e redesenha.
   *
   * @param {HTMLElement} caixa   o `[data-kit-qtd]` da linha
   * @param {number} kits         quantos kits a linha passa a ter; 0 remove
   */
  function gravar(caixa, kits) {
    if (ocupado) return;
    var linha = caixa.getAttribute('data-kit-line');
    var porKit = parseInt(caixa.getAttribute('data-kit-unidades'), 10);
    if (!linha || !(porKit > 1)) return;
    if (!(kits >= 0)) return;

    ocupado = true;
    caixa.setAttribute('aria-busy', 'true');

    pedir(ROTA + '/cart/change.js', { id: linha, quantity: kits * porKit })
      .then(function (cart) { return sincronizarTela(cart); })
      .catch(function () {})
      .then(function () {
        ocupado = false;
        caixa.removeAttribute('aria-busy');
      });
  }

  function kitsAtuais(caixa) {
    var campo = caixa.querySelector('[data-kit-input]');
    var n = campo ? parseInt(campo.value, 10) : NaN;
    return Number.isFinite(n) && n > 0 ? n : 1;
  }

  /* ── ganchos ───────────────────────────────────────────────────────────
     Delegado no documento porque a gaveta é redesenhada o tempo todo e um
     listener preso ao botão morreria no primeiro redesenho. */

  document.addEventListener('click', function (ev) {
    var botao = ev.target.closest && ev.target.closest('[data-kit-passo]');
    if (!botao) return;
    var caixa = botao.closest('[data-kit-qtd]');
    if (!caixa) return;

    ev.preventDefault();

    var passo = parseInt(botao.getAttribute('data-kit-passo'), 10) || 0;
    var novos = kitsAtuais(caixa) + passo;

    /* Descer do último kit é remover a linha — é o que o cliente espera do
       botão −, e é o que o controle do tema faz com a quantidade 1. */
    gravar(caixa, novos > 0 ? novos : 0);
  });

  document.addEventListener('change', function (ev) {
    var campo = ev.target;
    if (!campo || !campo.hasAttribute || !campo.hasAttribute('data-kit-input')) return;
    var caixa = campo.closest('[data-kit-qtd]');
    if (!caixa) return;
    var n = parseInt(campo.value, 10);
    gravar(caixa, Number.isFinite(n) && n > 0 ? n : 0);
  });
})();
